import { createContext, useContext } from "react";

export const UserContext: any = createContext([]);

export const useUserContext:any =()=> useContext(UserContext);
  
